/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import * as animation from '@constant/animation';

interface IProps {
  children?: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  background-color: ${color.MODAL_COLOR};

  ${animation.MODAL_BACKGROUND_FADE_IN_CSS}
`;

// TODO: modal에서 div 위치(padding) 조정하기
const ModalBackground: React.FC<IProps> = ({ children, onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      {/* children click 시, event 중지 */}
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </Wrapper>
  );
};

export default ModalBackground;
